import React, { useState, useEffect } from "react";
import { Typography, Pagination, Button, Card  } from "antd";
import { EditOutlined, DeleteOutlined} from "@ant-design/icons";
import Pageloader from "../../../../components/loader";
import { useNavigate } from "react-router-dom";
import { dataKey } from "../../../../utils/Helpers";
import DeleteConfirm from "../../../../components/deleteConfirm";
import * as notificationAction from "../../../../redux/actions/notification.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const { Title, Text } = Typography;

const pageName = "Categories";
const pageLink = "categories";

const CategoriesListing = (props) => {
  const navigate = useNavigate();
  const [postData, setPostData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if(props.categoriesFilter)
      postLists(props.categoriesFilter)
  }, [props.categoriesFilter]);
  
  const paginationChange = async (page, limit) => {
    const pageData = {
      ...props.categoriesFilter,
      page: page,
      limit: limit,
    };
    try {
      await props.notificationAction.filterCategoriesAction(pageData);
    } catch {}
  };

  const postLists = async (value) => {
    try {
      setLoading(true);
      await props.notificationAction.getCategoriesAction(value);
    } catch (e) {} finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
      if (props.categoriesData){setPostData(dataKey(props.categoriesData))}
  }, [props.categoriesData]);

  const postDelete = async (value) => {
    try {
      setLoading(true);
      await props.notificationAction.deleteCategoriesAction(value);
      paginationChange(1,10)
    } catch (e) {} finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-content">
      <div className="page-content-header">
          <Title level={2}>{pageName}</Title>
        <div className="pch">
          <Button onClick={()=>navigate(`/${pageLink}/add`)}>Add {pageName}</Button>
        </div>
      </div>
      <div className="p-content">
        {loading ? <Pageloader/> : <>
          <div className="page-list ffr aifs width-equal mb-0">
            {postData && postData.map((item, i) => {
              return (
                <Card 
                  key={i}
                  cover={
                    <div className="page-list ffr jfcsb aic mb-0" style={{background: item?.color, padding: "10px 24px", textShadow: "0px 0px 20px #fff"}}>
                      <span className="page-list ffr aic mb-0">{(<>Color Code: <b>{`${item?.color}`}</b></>)}</span>
                      
                      <span className="page-list ffr aic mb-0">
                        <DeleteConfirm title={item?.title} ID={item?.id} confirmDelete={postDelete} />
                        <EditOutlined onClick={()=>navigate(`/${pageLink}/add/${item?.id}`)} />
                      </span>
                    </div>
                  }
                >
                  <Text>{(<>Name: <b>{`${item?.title}`}</b></>)}</Text>
                </Card>
              );
            })}
          </div>
          {props?.categoriesPagination.length !== 0 ? 
            <Pagination className="ant-table-pagination ant-table-pagination-right"
              total={props?.categoriesPagination?.totalCount}
              showTotal={(total, range) => `${range[0]}-${range[1]} of ${total}`}
              pageSize={props?.categoriesPagination?.limit}
              defaultCurrent={props?.categoriesPagination?.currentPage} 
              pageSizeOptions={["10", "20", "30", "40", "50"]}
              showSizeChanger={true}
              onChange={(currentPage, pageSize) => {paginationChange(currentPage, pageSize)}}
            /> :""
          }
        </>}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    categoriesData: state.NotificationReducer.categoriesData,
    categoriesPagination: state.NotificationReducer.categoriesPagination,
    categoriesFilter: state.NotificationReducer.categoriesFilter,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    notificationAction: bindActionCreators(notificationAction, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CategoriesListing);